import {createContext} from 'react';
import type {EmailMakerActions, EmailMakerContextProps, EmailMakerImmutableStore} from './email-maker-react.types';
import {EMAIL_MAKER_INITIAL_STATE, EmailMakerMode} from './email-maker-react.types';

const noop = (): void => undefined;
const asyncNoop = (): Promise<boolean> => Promise.resolve(false);

const emailMakerDefaultStore: EmailMakerImmutableStore = {
  mode: EmailMakerMode.START,
  idEmailTemplate: null,
  templateName: '',
  idEmailMarketingCampaign: null,
  isApproved: false,
  isSharedInTeam: false,
  doesTemplateBelongToUser: false,
  doSetAutosaveActive: false,
  isEmailEditorAiTextGenerationEnabled: false,
  isEmailEditorAiImageGenerationViaPromptBoxEnabled: false,
  isEmailEditorAiDesignUpdatesViaPromptBoxEnabled: false,
  autoUpdateEmailContentParams: {
    autoUpdateEmailTemplateOnLoad: false,
    autoUpdateTextContentParams: null,
    autoUpdateBrandingParams: null,
  },
  puppeteerConfig: null,
  isSuperUser: false,
  isEmbedded: false,
  nextBtnCaption: '',
  elementsToHide: [],
};

const emailMakerDefaultActions: EmailMakerActions = {
  save: asyncNoop,
  undo: noop,
  redo: noop,
  setCanvasDevice: noop,
  selectComponent: noop,
  openRightPanelKeyboardShortcuts: noop,
  openRightPanelColorPalette: noop,
  openRightPanelColumnsAll: noop,
  openRightPanelColorPicker: noop,
  setColorPickerTarget: noop,
  openRightPanelVersionHistory: noop,
  closeRightPanelView: noop,
};

export const emailMakerContext = createContext<EmailMakerContextProps>({
  editor: null,
  store: emailMakerDefaultStore,
  state: EMAIL_MAKER_INITIAL_STATE,
  actions: emailMakerDefaultActions,
});
